// extracted by mini-css-extract-plugin
export default {"map":"MapBlock_map__B9pHg","marker-wrapper":"MapBlock_marker-wrapper__uy+cn","marker":"MapBlock_marker__Ll-SH","address":"MapBlock_address__orwsg","window":"MapBlock_window__HAvjV"};